import { CanMatchFn, Router } from '@angular/router'
import { OrganizationState } from '../../store/organization/organization.state'
import { inject } from '@angular/core'
import { defer, filter, map, switchMap, take } from 'rxjs'
import { NgxPermissionsService } from 'ngx-permissions'
import { Permission } from '../enums/permission.enum'
import { RouteName } from '../enums/route-name.enum'

export const userGuard: CanMatchFn = (route, segments) => {
  const organizationState = inject(OrganizationState)
  const permissionsService = inject(NgxPermissionsService)
  const router = inject(Router)

  return organizationState.state$.pipe(
    filter(state => !!state.userOrganization),
    take(1),
    switchMap(() =>
      defer(() => permissionsService.hasPermission(Permission.User))
    ),
    map(result => {
      if (!result) {
        router.navigateByUrl('/' + RouteName.Patients)
        return false
      }
      return result
    })
  )
}
